module.exports = __webpack_public_path__ + "img/9788937454516.1befcb69.jpg";